/* eslint-disable prettier/prettier */
// src/utils/validation.ts

/**
 * Industry-standard full name validation:
 * - At least 2 characters
 * - Only letters, spaces, dots, hyphens
 * - No numbers or special characters
 * - No leading/trailing spaces
 */
export const validateFullName = (name: string): string | null => {
	if (!name.trim()) {
		return 'Full name is required'; // optional field
	}

	if (name.trim().length < 2) {
		return 'Full name must be at least 2 characters';
	}

	const nameRegex = /^[A-Za-z][A-Za-z\s.'-]*$/;

	if (!nameRegex.test(name.trim())) {
		return 'Enter a valid full name (letters only)';
	}

	return null; // ✅ valid
};

/**
 * Industry-standard phone validation:
 * - E.164 compatible
 * - Allows +countrycode
 * - 7 to 15 digits
 */
export const validatePhoneNumber = (phone: string): string | null => {
	if (!phone.trim()) {
		return null; // optional field
	}

	if (!phone.startsWith('+')) {
		return 'Include country code (e.g. +91, +1)';
	}

	const phoneRegex = /^\+?[1-9]\d{9,14}$/;

	if (!phoneRegex.test(phone.trim())) {
		return 'Enter a valid phone number with country code';
	}

	if (phone.length > 16) {
		return 'Phone number is too long';
	}
	

	return null; // ✅ valid
};


export const formatPhoneNumber = (value: string): string => {
	// Remove everything except digits and +
	let cleaned = value.replace(/[^\d+]/g, '');

	// Allow only one "+" at start
	if (cleaned.includes('+')) {
		cleaned = '+' + cleaned.replace(/\+/g, '');
	}

	// Split country code & number
	if (cleaned.startsWith('+')) {
		const countryCodeMatch = cleaned.match(/^\+\d{1,3}/); // +91, +1 etc

		if (countryCodeMatch) {
			const countryCode = countryCodeMatch[0];
			let rest = cleaned.slice(countryCode.length);

			// 🔥 LIMIT TO 10 DIGITS AFTER COUNTRY CODE
			rest = rest.replace(/\D/g, '').slice(0, 10);

			return countryCode + rest;
		}
	}

	return cleaned;
};

/**
 * Industry-standard address validation (without country):
 * - Required
 * - Minimum 5 characters
 * - Allows letters, numbers, spaces
 * - Allows , . / - #
 * - No emojis or special symbols
 */
export const validateAddress = (address: string): string | null => {
	if (!address.trim()) {
		return null; // optional field
	}

	if (address.trim().length < 5) {
		return 'Address must be at least 5 characters';
	}

	const addressRegex = /^[A-Za-z0-9][A-Za-z0-9\s,./#-]*$/;

	if (!addressRegex.test(address.trim())) {
		return 'Enter a valid address';
	}

	return null; // ✅ valid
};
